import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener('click', () => this.toggleMenu());
  }

  toggleMenu() {
    let sidebar = document.querySelector('#logo-sidebar');
    !!sidebar && sidebar.setAttribute('aria-menu', this.toggle(sidebar.getAttribute('aria-menu')));
  }

  toggle(state) {
    if(state == 'closed')
      return 'opened';

    return 'closed';
  }
}